module.exports = __webpack_public_path__ + "static/media/visa.b966bac5.svg";